import { Grid, Radio, Stack, Typography } from "@mui/material";
import { useContext } from "react";

import ThemeContext from "../../../Products/context";
import Context from "../../context";

// ----------------------------------------------------------------------

type Props = {
	onChangeSelect: (value: string) => void;
	selectedValue: string;
};

export const RadioSelector = ({ onChangeSelect, selectedValue }: Props) => {
	const { params } = useContext(Context);
	const { theme } = useContext(ThemeContext);

	const radioSelector = params.find((field) => field.type === "radio");

	return (
		<Grid container columnGap={1}>
			{radioSelector?.options.map((option, index) => (
				<Grid item key={index}>
					<Stack direction={"row"} alignItems={"center"}>
						<Radio
							onClick={() => onChangeSelect(option.value)}
							size='small'
							checked={selectedValue === option.value}
							sx={{
								p: 0.5,
								"&, &.Mui-checked": {
									color:
										selectedValue === option.value
											? theme?.colors.primary
											: theme?.colors.secondaryText
								}
							}}
						/>
						<Typography
							variant='body1'
							fontSize={13}
							color={
								selectedValue === option.value
									? theme?.colors.primaryText
									: theme?.colors.secondaryText
							}
							onClick={() => onChangeSelect(option.value)}
							sx={{ cursor: "pointer" }}
						>
							{option.label}
						</Typography>
					</Stack>
				</Grid>
			))}
		</Grid>
	);
};

export default RadioSelector;
